import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, takeWhile } from 'rxjs';
import { PartnerDataModel } from 'src/app/account/models/accountModel';
import { AccountService } from 'src/app/account/services/account.service';
import { ManagementService } from 'src/app/management/services/management.service';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {

  isLoggedIn = false;

  isMngLoggedIn = false;

  isMngHeaderVisible = false;

  isNavBarVisible = false;

  user: PartnerDataModel;

  destroySubscription = false;

  routerSubscription: any;

  isHeader = false;

  isAuthScreen = false;

  @HostBinding('class.has-store-info-bar')
  get showStoreInfoBar(): boolean {
    return !this.isMngHeaderVisible && this.isHeader && !this.isLoggedIn && !this.isAuthScreen;
  }

  constructor(private sharedService: SharedService, private accountService: AccountService, private managementService: ManagementService, private router: Router) {

    this.sharedService.brandColorSrc.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          if (response.brandColor1 || response.brandColor2) {
            const cssURL: any = this.sharedService.createBrandCss(response.brandColor1, response.brandColor2);
            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.id = 'css-styling';
            style.append(cssURL)
            // style.rel = 'stylesheet';
            // style.href = `${cssURL}`;
            head.appendChild(style);
          }
        }
      });
    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        if (event && ((event.url.indexOf('dashboard/main') > -1)
          || (event.urlAfterRedirects && event.urlAfterRedirects === '/dashboard/main')
          || (event.url.indexOf('dashboard/login') > -1)
          || (event.url.indexOf('dashboard/createpartner') > -1)
          || (event.url.indexOf('dashboard/app/') > -1)
          || (event.url.indexOf('dashboard/apps') > -1))) {
          this.isHeader = true;
        } else {
          const user = this.accountService.getUser();
          if (user) {
            this.isHeader = true;
          }
        }
        if (event && ((event.url.indexOf('manage') > -1))) {
          this.isMngHeaderVisible = true;
        } else {
          this.isMngHeaderVisible = false;
        }

        this.isAuthScreen = !!(event && ((event.url.indexOf('dashboard/login') > -1)
          || (event.url.indexOf('dashboard/createpartner') > -1)));

        if (event && ((event.url.indexOf('manage/main') > -1)
          || (event.url.indexOf('manage/appstates') > -1)
          || (event.url.indexOf('manage/partner') > -1)
          || (event.url.indexOf('manage/vendor') > -1)
          || (event.url.indexOf('manage/auditlogs') > -1)
          || (event.url.indexOf('manage/wflogs') > -1)
        )) {
          this.isNavBarVisible = true;
        } else {
          this.isNavBarVisible = false;
        }
      });
  }

  ngOnInit(): void {
    const isAuthenticated = this.accountService.isAuthenticated();
    if (isAuthenticated) {
      this.preInit();
    }
    this.accountService.isLoggedIn.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.preInit();
        } else {
          this.isLoggedIn = false;
        }
      });

    this.managementService.isMngLoggedIn.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.isMngLoggedIn = true;
        } else {
          this.isMngLoggedIn = false;
        }
      });
  }


  preInit() {
    this.isLoggedIn = true;
    this.user = this.accountService.getUser() ? this.accountService.getUser() : null;
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
